export const delay = (ms: any) => {
    return new Promise((res) => {
        setTimeout(res, ms);
    });
};

export const splitString = (word: any) => {
    const parts = word.split(' ');
    const finalList = [];
    finalList.push(parts[0]);
    for (let i = 1; i < parts.length; i++) {
        if (parts[i].length < 3) {
            finalList[finalList.length - 1] = finalList[finalList.length - 1] + ' ' + parts[i];
        } else {
            finalList.push(parts[i]);
        }
    }
    return finalList;
};

export const getLastFromSplit = (str: any, sep: any) => {
    const parts = str.split(sep);
    return parts[parts.length - 1];
};


